import { useAuthenticatedApiFetch } from './useAuthenticatedApiFetch';
import ApiConstants from '../utils/ApiConstants';

export const useSaveQuestions = () => {
  const authenticatedApiFetch = useAuthenticatedApiFetch();

  const saveQuestions = async (
    updatedQuestions,
    product,
    client,
    subArea,
    firstLevelArea,
    secondLevelArea,
    mainProductId,
    goToResults
  ) => {
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(mainProductId && { 'mainproductid': mainProductId }),
      },
      body: JSON.stringify(updatedQuestions),
    };

    const areaIdToUse = secondLevelArea || firstLevelArea;

    // base URL
    let url = `${ApiConstants.BASE_URL}${ApiConstants.getSaveQuestionsEndpoint(
      product,
      areaIdToUse,
      subArea,
      client
    )}`;

    // Append ?goToResults=true only if goToResults is true
    if (goToResults) {
      url += '?goToResults=true';
    }

    return await authenticatedApiFetch(url, options);
  };

  return { saveQuestions };
};
